const unquotedString = {
  match: /[^"'`<>=*!+()\s]+/,
}

export default unquotedString
